import { render, staticRenderFns } from "./PageCheckoutSuccess.vue?vue&type=template&id=7c1b0875&"
import script from "./PageCheckoutSuccess.vue?vue&type=script&lang=js&"
export * from "./PageCheckoutSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1b0875')) {
      api.createRecord('7c1b0875', component.options)
    } else {
      api.reload('7c1b0875', component.options)
    }
    module.hot.accept("./PageCheckoutSuccess.vue?vue&type=template&id=7c1b0875&", function () {
      api.rerender('7c1b0875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageCheckoutSuccess.vue"
export default component.exports